<template>
    <div class="machine-inspector">
        <div class="title">
            Machine ID: {{ id }}
        </div>
        <div class="current-status">
            <button @click="start()">Start</button>
            <button @click="execute(false)">Execute</button>
            <button @click="execute(true)">Execute To</button>
            <input type="input" v-model="toPC">
            <span>Current PC: {{pc}}</span>
        </div>
        <div class="wrapper">
            <div class="instructions">
                <strong>Instrucciones</strong>
                <table >
                  <tr>
                    <th>Ins #</th>
                    <th>Name</th>
                    <th>Op1</th>
                    <th>Op2</th>
                    <th>Context</th>
                    <th>fromLine</th>
                    <th>ident</th>
                  </tr>
                  <tr v-for="(ins, index) in instructions" v-bind:id="'ins' + index" v-bind:class="{'active': index === pc}">
                    <td>{{index}}</td>
                    <td>{{ins.name}}</td>
                    <td>{{ins.op1}}</td>
                    <td>{{ins.op2}}</td>
                    <td>{{ins.context}}</td>
                    <td>{{ins.debug.fromLine + 1}}</td>
                    <td>{{ins.debug.ident}}</td>
                  </tr>
                </table>
            </div>
            <div class="stack">
                <strong>Stack</strong>
                <table >
                  <tr>
                    <th>Cell #</th>
                    <th>Type</th>
                    <th>Value</th>
                    <th>Variable</th>
                  </tr>
                  <tr v-for="(cell, index) in stack" >
                    <td>{{index}}</td>
                    <td>{{cell.type}}</td>
                    <td>{{cell.value}}</td>
                    <td>{{cell.variable}}</td>
                  </tr>
                </table>
                <div style="margin-top: 20px;"><strong >Display</strong></div>
                <table >
                  <tr>
                    <th>Cell #</th>
                    <th>Value</th>
                  </tr>
                  <tr v-for="(cell, index) in display" >
                    <td>{{index}}</td>
                    <td>{{cell.value}}</td>
                  </tr>
                </table>
            </div>
            <div class="memory">
                <strong>Heap (Length: {{ heap_length }})</strong>
                <table >
                  <tr>
                    <th>Cell #</th>
                    <th>Type</th>
                    <th>Value</th>
                    <th>Variable</th>
                  </tr>
                  <tr v-for="(cell, index) in heap" >
                    <td>{{index}}</td>
                    <td>{{cell.type}}</td>
                    <td>{{cell.value}}</td>
                    <td>{{cell.variable}}</td>
                  </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MachineInspector',
        props: ['id'],
        components: {
        },
        created () {
        },
        mounted () {
        },
        methods: {
            start () {
                let program = window.vms[this.id].getProgram()
                window.vms[this.id].setProgram(program)
                this.pc = window.vms[this.id].pc
                this.status = this.translateStatus(status)
                this.refreshMachine()
                this.updateStack()
                this.updateDisplay()
                this.updateHeap()
            },
            execute (executeToGivenPC) {
                let oneMoreStep = true
                let status
                while (oneMoreStep) {
                    status = window.vms[this.id].executeStep()
                    this.pc = window.vms[this.id].pc
                    this.status = this.translateStatus(status)
                    this.updateStack()
                    this.updateDisplay()
                    this.updateHeap()
                    let domElem = document.getElementById('ins' + this.pc)
                    if (domElem) {
                        domElem.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'})
                    }
                    if (executeToGivenPC) {
                        oneMoreStep = this.pc < this.toPC
                    } else {
                        oneMoreStep = false
                    }
                }
            },
            translateStatus (status) {
                if (status === 5000) {
                    return 'OK_SIGNAL'
                }
                if (status === 1000) {
                    return 'READ_SIGNAL'
                }
                if (status === 1001) {
                    return 'WRITE_SIGNAL'
                }
                if (status === 1002) {
                    return 'WAIT_TIME_SIGNAL'
                }
                if (status === 1003) {
                    return 'EXTERNAL_FUNC_SIGNAL'
                }
                if (status === 1004) {
                    return 'ERROR_SIGNAL'
                }
                if (status === 1005) {
                    return 'END_SIGNAL'
                }
                if (status === 1006) {
                    return 'CLEAR_SIGNAL'
                }
                if (status === 1007) {
                    return 'WAIT_KEY_SIGNAL'
                }
                if (status === 2001) {
                    return 'EXEC_TO_NEXT_INS'
                }
                if (status === 2002) {
                    return 'EXEC_TO_NEXT_LINE'
                }
                if (status === 2003) {
                    return 'EXEC_TO_NEXT_IO'
                }
            },
            updateHeap () {
                let heap = window.vms[this.id].memory.heap
                this.heap_length = heap.length
                this.heap = []
                for (let cell of heap) {
                    this.heap.push({
                        type: this.getOp(cell.type),
                        value: this.getOp(cell.value),
                        variable: this.getOp(cell.data)
                    })
                }
            },
            updateDisplay () {
                let display = window.vms[this.id].memory.display
                this.display = []
                for (let cell of display) {
                    this.display.push({
                        value: cell
                    })
                }
            },
            updateStack () {
                let stack = window.vms[this.id].memory.stack
                this.stack = []
                for (let cell of stack) {
                    this.stack.push({
                        type: cell.type.toString(),
                        value: cell.value,
                        variable: this.getOp(cell.data)
                    })
                }
            },
            updateCurrentIns () {
                // this.currentIns =
            },
            refreshMachine () {
                let program = window.vms[this.id].getProgram()
                this.instructions = []
                for (let ins of program.instructions) {
                    this.instructions.push({
                        name: program.inverse[ins.instruction],
                        op1: this.getOp(ins.op1),
                        op2: this.getOp(ins.op2),
                        context: ins.context,
                        debug: {
                            fromLine: this.getDebugAttr(ins, 'fromLine'),
                            fromColumn: this.getDebugAttr(ins, 'fromColumn'),
                            toLine: this.getDebugAttr(ins, 'toLine'),
                            toColumn: this.getDebugAttr(ins, 'toColumn'),
                            ident: this.getDebugAttr(ins, 'ident'),
                            procName: this.getDebugAttr(ins, 'procName')
                        }
                    })
                }
            },
            getDebugAttr (ins, attr) {
                if (ins.debug !== undefined && ins.debug !== null) {
                    if (ins.debug[attr] !== undefined && ins.debug[attr] !== null) {
                        return ins.debug[attr]
                    }
                }
                return '-'
            },
            getOp (op) {
                if (op === undefined || op === null) {
                    return ''
                } else if (typeof op === 'object') {
                    return op.toString()
                }
                return op
            }
        },
        data () {
            return {
                instructions: [],
                heap: [],
                heap_length: 0,
                stack: [],
                display: [],
                currentIns: '',
                pc: -1,
                toPC: 0
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.machine-inspector {
    box-sizing: border-box;
    position: fixed;
    left: 10px;
    top: 350px;
    bottom: 10px;
    right: 10px;
    background-color: #F0F0F0;
    border: 1px solid black;
    z-index: 1000;
    overflow: hidden;
    font-family: monospace;
}
.current-status {
    min-height: 60px;
    padding: 10px;
}
.wrapper {
    position: absolute;
    top: 70px;
    left: 0px;
    right: 0px;
    bottom: 10px;
}
.wrapper > div {
    padding: 0px;
    display: inline-block;
}
.instructions  {
    width: 44%;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 10px;
    overflow-y: auto;
    font-size: 12px;
}

.stack  {
    position: absolute;
    top: 0px;
    width: 25%;
    bottom: 0px;
    left: 46%;
    overflow-y: auto;
}
.memory  {
    position: absolute;
    top: 0px;
    width: 27%;
    bottom: 0px;
    left: 72%;
    overflow-y: auto;
}
table {
    width: 100%;
    border: 1px solid #AAA;
    border-collapse: collapse;
}
table td, table th {
    border: 1px solid #AAA;
    padding: 4px;
    text-align: center;
    padding: 1px;
    margin: 1px;
}
table tr.active {
    background-color: #F0F080;
}
</style>


// WEBPACK FOOTER //
// src/Components/CodeEditor/MachineInspector.vue